import api from '@/api';

export default {
	// 开启命名空间
	namespaced:true,
	actions:{
		// 获取用户信息
    async updateUserInfo({state, commit}, val) {
      await state.getUserInfo({ autoLogin: true }).then((res) => {
        commit('setUser', res.data);
      })
    },
		// 获取收藏列表
		async getCollectList({state, commit}, val) {
			await state.collectList({ keyword: val }).then((res) => {
				if (res.success) {
					// const collectList = res.data.map(item => {
					// 	const textTitle = item.input;
					// 	const textContent = item.reply;
					// 	return { ...item, textTitle, textContent };
					// });
					// commit('setCollectList', collectList);
					commit('setCollectList', res.data);
				}
			})
		},
	},
	mutations:{
		setUser(state, val){
			state.user = val;
		},
		setCollectList(state, val) {
			state.collectListData = val;
		},
		// 删除收藏
		deleteCollect(state, val) {
			const newCollList = state.collectListData.filter(item => item.conversationId !== val);
			state.collectListData = newCollList;
		},
		changeAutoLogin(state, val) {
			state.autoLogin = val;
		},
		changeAiAssistantId(state, val){
			state.aiAssistantId = val;
		},
		changeAiAssistant(state, val) {
			state.aiAssistant = val;
		},
		changeIsAuth(state, val) {
			state.isAuth = val;
		},
	},
	state:{
		user: { name: 'human', imageUrl: '', availableAmount: 0, temperature: 0 },
		getUserInfo: api.getUserInfo,
		collectList: api.collectList,
		collectListData: [],
		autoLogin: false,
		aiAssistantId: null,
		aiAssistant: {},
		sessionKey: 'sessionKey',
		isAuth: false,
	},
	getters:{
 
	},
}